/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable max-lines */
import styled from 'styled-components'

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 16px;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  position:relative;

  padding: 8px 12px;
  border: 1px solid #D4D4D6;
  border-radius: 4px;
`

export const StyledLoader = styled.div`
  position:absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  div {
    opacity: 0;
  }
`

export const StyledMain = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 8px;
`

export const StyledLabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-self: stretch;
  gap: 4px;
  align-items: center;

  span {
    font-weight: 400;
    font-size: 14px;
    line-height: 26.4px;
    color: #3E3E47;

    button {
      font-weight: 400;
      font-size: 14px;
      line-height: 26.4px;
      text-decoration: underline;
      color: #3E3E47;
      border: 0;
      background: #FFFFFF;
      cursor: pointer;
    }
  
    button.ppp-learn-more-button__mobile {
      display: none;
      padding: 0;
      line-height: 10px;
    }
  }

  span.ppp-label-logo {
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
  }

  @media (max-width: 1350px) {
    span {
      font-size: 14px;
      line-height: 23.1px;

      button.ppp-learn-more-button__desktop {
        display: none;
      }

      button.ppp-learn-more-button__mobile {
        display: block;
      }
    }
  }

  @media (min-width: 497px) and (max-width: 992px) {
    span {

      button.ppp-learn-more-button__desktop {
        display: block;
      }

      button.ppp-learn-more-button__mobile {
        display: none;
      }
    }
  }

  @media (max-width: 378px), (min-width: 993px) and (max-width: 1187px) {
    flex-direction: column;
    align-items: start;
    gap: 2px;
  }
`

export const StyledOptionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-self: stretch;
  gap: 8px;


  @media (max-width: 449px), (min-width: 993px) and (max-width: 1264px) {
    gap: 4px;
  }
`

export const StyledButton = styled.button`
  border: 1px solid #3E3E47;
  border-radius: 4px;
  padding: 8px;
  height: auto;
  background-color: #FFFFFF;
  cursor: pointer;
  flex: 1;

  &:hover {
    background-color: #FFF0B4;
  }

  span {
    font-weight: 600;
    font-size: 14px;
    color: #3E3E47;
    line-height: 23.1px;
    font-family: "Roboto", Arial, Helvetica, sans-serif;
  }

  &.product-protection-plan-selected {
    background-color: #282832;
    border: 1px solid #282832;

    span {
      color: #FFFFFF;
    }
  }

  @media (max-width: 433px), (min-width: 993px) and (max-width: 1182px) {
    padding: 8px;

    span {
      font-size: 12px;
      line-height: 19.8px;
      font-weight: 600;
    }
  }
`
